import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, map, switchMap } from 'rxjs/operators';
import { of } from 'rxjs';
import { StatisticsCountDto } from '@smmof/dto';
import { StatisticsActions } from '../actions/statistics.actions';
import { ApiServerService } from '../../shared/services/api-server.service';

@Injectable()
export class StatisticsEffects {
  constructor(
    private actions$: Actions,
    private apiService: ApiServerService
  ) {}

  /** Эффект для получения статистики */
  getStatistics$ = createEffect(() =>
    this.actions$.pipe(
      ofType(StatisticsActions.getStatistics),
      switchMap(() =>
        this.apiService.GET<StatisticsCountDto>('statistics/count').pipe(
          map((statistics) => StatisticsActions.getStatisticsSuccess({ statistics })),
          catchError((error) => of(StatisticsActions.getStatisticsFailure({ error })))
        )
      )
    )
  );
}
